import { searchCategories } from 'shared/constants/searchCategories';

const mapCountries = (country, continent, continentCode, isSearchable) => ({
  ...country,
  continent,
  continentCode,
  ...(isSearchable
    ? { category: searchCategories.COUNTRY, group: continent, value: country.iso }
    : {}),
});

export const regionsParser = (regions, isSearchable = false) => {
  return regions.reduce((current, next) => {
    let total = current;

    if (!Array.isArray(current)) {
      total = current.countries.map(country =>
        mapCountries(country, current.continent, current.continentCode, isSearchable),
      );
    }

    return [
      ...total,
      ...next.countries.map(country =>
        mapCountries(country, next.continent, next.continentCode, isSearchable),
      ),
    ];
  }, []);
};
